<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'query'"
    class="page"
  >
    <div class="mt2 mb4 fs5 fw4 fc--primary">
      {{ clinicInfo.fullname }}
    </div>
    <div class="page__form">
      <input
        type="text"
        placeholder="身份證號碼"
        v-model="memberInfo.id"
      >
      <input
        type="text"
        placeholder="西元生日 共八碼"
        v-model="memberInfo.birthdate"
      >
      <div
        class="label label--primary mt3"
        @click="query"
      >
        查詢
      </div>
    </div>
  </div>

  <div
    v-else-if="page == 'appointmentList'"
    class="page"
  >
    <div class="mt2 mb4 fs5 fw4 fc--primary">
      {{ clinicInfo.fullname }}
    </div>
    <div
      class="section mb3"
      v-for="(appointment, index) in appointments"
      :key="index"
      @click="showCancelConfirmation(index)"
    >
      <div class="circle circle--secondary circle--size-7 column--central">
        <div class="fs3">
          {{ appointment.date.slice(5, 10).replace("-", "/") }}
        </div>
        <div class="fs1">
          {{ appointment.timeSlotName }}
        </div>
      </div>
      <div class="column--central">
        <div class="mv1">
          {{ appointment.doctor }}
        </div>
        <div class="fc--secondary fs1 mv1">
          醫師
        </div>
      </div>
      <div class="column--central">
        <div class="fs1 mv1">
          最晚報到時間
        </div>
        <div class="fc--primary mv1">
          {{ appointment.endCheckInTime }}
        </div>
      </div>
      <div class="column--central">
        <div class="fc--primary fs5 mv1">
          {{ appointment.waitingNumber }}
        </div>
        <div class="fc--secondary fs1 mv1">
          預約號碼
        </div>
      </div>
      <div class="column--central">
        <div class="circle circle--secondary circle--size-2 row--central fs1">
          <font-awesome-icon :icon="['fas', 'times']" />
        </div>
      </div>
    </div>

    <div class="page__text mb4">
      <div v-if="appointments.length > 0">
        <p>若欲更改預約</p>
        <p>請先取消預約後另約其他天</p>
      </div>
      <div v-else>
        無預約資料
      </div>
    </div>
    <div class="row--evenly">
      <div
        class="label label--secondary mh1"
        @click="liff.closeWindow"
      >
        返回主畫面
      </div>
      <div
        class="label label--primary mh1"
        @click="page = 'query'"
      >
        重新查詢
      </div>
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @confirm="cancelAppointment"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import composable from '@/composable/index';

export default {
  setup() {
    const route = useRoute();
    const page = ref('initialization');
    const clinicInfo = ref(null);
    const memberInfo = ref({
      id: null,
      birthdate: null,
    });
    const appointments = ref([]);
    let cancelIndex = null;

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        const { clinic } = route.params;
        if (clinic === 'heart') {
          await composable.member.initialize({
            liffId: '1656042583-KDVl74vL',
            clinic: '金安心',
          });
        } else if (clinic === 'beauty') {
          await composable.member.initialize({
            liffId: '1656042583-48b0xkQ7',
            clinic: '金禾美',
          });
        }
        clinicInfo.value = spiderman.clinic[composable.member.info.clinic];

        if (composable.member.info.verified) {
          memberInfo.value = {
            id: composable.member.info.twid,
            birthdate: composable.member.info.birthdate,
          };
        }
        page.value = 'query';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    async function query() {
      try {
        spiderman.form.verify(memberInfo.value);
        memberInfo.value.birthdate = spiderman
          .moment(memberInfo.value.birthdate)
          .format('YYYY-MM-DD');

        composable.loading.show('預約記錄查詢中，請稍候。');

        appointments.value = await api.appointments.query(
          composable.member,
          memberInfo.value,
        );

        page.value = 'appointmentList';
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function showCancelConfirmation(index) {
      composable.modal.confirm(
        `確定刪除 ${
          appointments.value[index].doctor
        }醫師 ${spiderman.moment(appointments.value[index].date).format('MM/DD')} ${
          appointments.value[index].timeSlotName
        }嗎？`,
      );
      cancelIndex = index;
    }

    async function cancelAppointment() {
      try {
        composable.modal.close();
        composable.loading.show('預約刪除中，請稍候。');
        await api.appointments.cancel(
          composable.member,
          memberInfo.value,
          appointments.value[cancelIndex],
        );
        appointments.value.splice(cancelIndex, 1);

        composable.modal.popup('預約刪除成功');
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    return {
      liff: spiderman.liff,
      composable,
      page,
      clinicInfo,
      memberInfo,
      query,
      appointments,
      showCancelConfirmation,
      cancelAppointment,
    };
  },
};
</script>
